{
  "slug": "nikola-tesla-iq",
  "title": "Nikola Tesla IQ: what is actually known?",
  "description": "A careful review of reported Nikola Tesla IQ claims and why popular numbers are unverified.",
  "category": "Famous people and IQ claims",
  "sections": [
    {
      "heading": "Documented achievement",
      "paragraphs": [
        "Tesla’s alternating-current and engineering work is historically documented. Inventive output does not reveal a standardized IQ score.",
        "Achievement can involve knowledge, persistence, creativity, collaboration, opportunity, and specialist expertise. It cannot be translated into a unique IQ number."
      ]
    },
    {
      "heading": "Evidence behind the reported number",
      "paragraphs": [
        "Tesla was born before modern IQ testing. Retrospective values are biographical speculation, not age-normed results.",
        "A credible claim would identify the instrument, version, date, administration conditions, norm group, score type, and a reliable primary record. Viral lists rarely provide that chain."
      ]
    },
    {
      "heading": "Responsible conclusion",
      "paragraphs": [
        "Treat a number as unverified unless a primary record is available. Separate admiration for achievement from psychometric measurement.",
        "The conclusion is not that the person lacked ability; it is that the precise number is unknown."
      ]
    }
  ],
  "related": ["what-is-iq", "how-is-iq-measured", "iq-vs-intelligence"],
  "sources": [
    {
      "label": "Smithsonian — Nikola Tesla collection",
      "url": "https://americanhistory.si.edu/collections/object-groups/nikola-tesla"
    }
  ],
  "faqs": [
    {
      "question": "What was Nikola Tesla’s IQ?",
      "answer": "No authenticated standardized score is publicly established. Precise values repeated online should be treated as speculation."
    },
    {
      "question": "Can achievement be converted into IQ?",
      "answer": "No. Achievement and test performance overlap only partly and use different evidence."
    }
  ],
  "summary": "A careful review of reported Nikola Tesla IQ claims and why popular numbers are unverified. Content reviewed 18 July 2026."
}
